import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Collapse } from "reactstrap";
import { Minus, Plus } from 'lucide-react';
import DownloadButton from './DownloadButton';
import './Widget.css';

const Widget = ({ widget, analysisRun }) => {
  // Expand widgets by default
  const [isOpen, setIsOpen] = React.useState(true);
  const headerClassName = `widget-header ${!isOpen ? 'widget-header-collapsed' : ''}`;

  return (
    <div className="widget-container">
      <div className={headerClassName} style={{ background: widget.color }}>
        <span className="widget-title">{widget.title}</span>
        <div className="widget-header-actions">
          {/* Download button: only show if analysis has run and widget has image */}
          {analysisRun && widget.image && (
            <DownloadButton 
              image={widget.image} 
              title={widget.title}
              widgetId={widget.id}
            />
          )}
          {/* widget collapse/expand button */}
          {isOpen ? (
            <Minus size={20} className="widget-collapse-icon" onClick={() => setIsOpen(!isOpen)}/>
          ) : (
            <Plus size={20} className="widget-collapse-icon" onClick={() => setIsOpen(!isOpen)}/>
          )}
        </div>
      </div>
      
      <Collapse isOpen={isOpen}>
        <div className="widget-content" id={`widget-${widget.id}`}>
          {/* display analysis results (pngs) */}
          {analysisRun ? (
            widget.image ? (
              <img src={widget.image} alt={widget.title} className="widget-image" />
            ) : (
              'Analysis completed - Results would appear here'
            )
          ) : (
            'Please run analysis to see results'
          )}
        </div>
      </Collapse>
    </div>
  );
};

export default Widget;